$(document).ready(function() {
    // Get the product tags from the data attribute
    var productTags = $('.container').data('tags');

    if (productTags) {
        var tagsArray = productTags.split(',');

        // ✅ MOQ Handling
        var qtyInput = $('input[name="quantity"]');
        var addToCartBtn = $('form[action="/cart/add"] button');
        var decrementBtn = qtyInput.siblings('.decrement-button'); // Adjust if necessary
        var purchaseDetails = $('.purchase-details__quantity.product-quantity-box'); // Target for message placement
        var minQty = 1; // Default minimum order quantity

        // Create and insert MOQ message element (if not already present)
        if (!$('.moq-message').length) {
            $('<div class="moq-message" style="width: 100%; display: none; color: red; font-size: 14px; margin-top: 5px;"></div>')
                .insertAfter(purchaseDetails);
        }
        var moqMessage = $('.moq-message');

        // Check for MOQ tag (e.g., "MOQ-10")
        tagsArray.forEach(function(tag) {
            if (tag.startsWith("MOQ-")) {
                minQty = parseInt(tag.replace("MOQ-", ""), 10);
            }
        });

        // ✅ Show/hide MOQ message
        if (minQty > 1) {
            moqMessage.show().text("Minimum order quantity: " + minQty);
        } else {
            moqMessage.hide();
        }

        // ✅ Set the minimum quantity when the page loads
        if (qtyInput.length) {
            qtyInput.val(minQty);
            qtyInput.attr('min', minQty); // Enforce minimum value
        }

        // ✅ Disable decrement button if MOQ is enforced
        if (decrementBtn.length && parseInt(qtyInput.val()) <= minQty) {
            decrementBtn.prop('disabled', true);
        }

        // ✅ Prevent users from setting quantity below MOQ
        qtyInput.on("change keyup", function() {
            var currentQty = parseInt(qtyInput.val()) || 0;

            if (currentQty < minQty) {
                qtyInput.val(minQty);
            }

            // Disable "Add to Cart" if below MOQ
            addToCartBtn.prop("disabled", currentQty < minQty);

            // Disable decrement button if at MOQ
            if (decrementBtn.length) {
                decrementBtn.prop('disabled', currentQty <= minQty);
            }
        });

        // ✅ Ensure decrement button cannot decrease below MOQ
        decrementBtn.on("click", function() {
            var currentQty = parseInt(qtyInput.val()) || 0;

            if (currentQty <= minQty) {
                qtyInput.val(minQty);
                return false;
            }
        });

    }
});
